import { INTELLIGENT_PHOTO_CAPTURE_UPDATE_USER_VEHICLE_INFO, INTELLIGENT_PHOTO_CAPTURE_SET_OCR_USER_VERIFIED } from '../actions';
import { attachmentInfo } from '../utilities';
export const photoCaptureIntelligentUserVehicleInfoReducer = (state, action) => {
    switch (action.type) {
        case INTELLIGENT_PHOTO_CAPTURE_UPDATE_USER_VEHICLE_INFO: {
            const payload = action.payload;
            return Object.assign(Object.assign({}, state), { userVehicleInfo: payload.userVehicleInfo });
        }
        case INTELLIGENT_PHOTO_CAPTURE_SET_OCR_USER_VERIFIED:
            return Object.assign(Object.assign({}, state), { ocrUserVerification: attachmentInfo.setOCRUserVerifiedState(state.ocrUserVerification, action.payload.contentType) });
        default:
            return state;
    }
};
//# sourceMappingURL=photoCaptureIntelligentUserVehicleInfoReducer.js.map